// import React, { useState } from "react";
// import { Briefcase, MapPin, Clock, ArrowRight, MoveRight } from "lucide-react";
// import { useNavigate } from "react-router-dom";
// import { jobs } from "../../data/JobData";

// const filters = [
//   "All",
//   "Engineering",
//   "Design",
//   "Marketing",
//   "Data",
//   "Customer Success",
// ];

// const positions = [
//   {
//     id: 1,
//     category: "Engineering",
//     title: "Senior Full-Stack Engineer",
//     description:
//       "Build scalable web applications using React, Node.js, and modern cloud infrastructure.",
//     location: "Remote / San Francisco",
//     type: "Full time",
//   },

//   {
//     id: 3,
//     category: "Engineering",
//     title: "DevOps Engineer",
//     description:
//       "Architect and maintain our cloud infrastructure, CI/CD pipelines, and deployment systems.",
//     location: "Remote",
//     type: "Full time",
//   },
//   {
//     id: 4,
//     category: "Marketing",
//     title: "Marketing Manager",
//     description:
//       "Drive brand awareness and growth through creative campaigns and strategic partnerships.",
//     location: "Hybrid / Los Angeles",
//     type: "Full time",
//   },
//   {
//     id: 5,
//     category: "Data",
//     title: "Data Scientist",
//     description:
//       "Extract insights from complex datasets and build ML models that power our products.",
//     location: "Remote / Boston",
//     type: "Full time",
//   },
//   {
//     id: 6,
//     category: "Customer Success",
//     title: "Customer Success Lead sdfjabfjagulo",
//     description:
//       "Be the voice of our customers and ensure they achieve amazing outcomes with our platform.",
//     location: "Remote",
//     type: "Full time",
//   },
// ];

// export default function OurPositions() {
//   const navigate = useNavigate();
//   const [active, setActive] = useState("All");

//   const filteredPositions =
//     active === "All"
//       ? jobs
//       : jobs.filter((p) => p.category === active);

//   return (
//     <div className="w-full py-20 px-4 lg:px-16 bg-gray-50 min-h-screen">
//       <div className="text-center space-y-6 mb-12">
//         <span className="text-[#2A9CD7] font-semibold tracking-wider text-sm px-4 py-2 rounded-full border border-blue-200">
//           OPEN POSITIONS
//         </span>
//         <h2 className="text-4xl md:text-5xl text-[#093a5b] font-bold ">
//           Find Your Perfect Role
//         </h2>
//         <p className="text-gray-600 text-lg max-w-2xl mx-auto">
//           We're always looking for talented individuals who are passionate about
//           making an impact.
//         </p>
//       </div>

//       {/* Tabs */}
//       <div className="flex flex-wrap justify-center gap-3 mb-10">
//         {filters.map((f) => (
//           <button
//             key={f}
//             onClick={() => setActive(f)}
//             className={`px-4 md:px-6 py-2 rounded-full text-sm md:text-base font-medium transition-all border shadow-sm duration-300
//               ${active === f
//                 ? "bg-[#093A5B] text-white border-[#093A5B]"
//                 : "bg-white text-gray-600 border-gray-200"
//               }`}
//           >
//             {f}
//           </button>
//         ))}
//       </div>

//       {/* Job Cards */}
//       <div className="grid sm:grid-cols-2 lg:grid-cols-2 gap-6 max-w-6xl mx-auto duration-300">
//         {filteredPositions.map((job) => (
//           <div
//             key={job.id}
//             className="group bg-white p-6 rounded-xl shadow-sm border border-gray-200 hover:shadow-md transition-all hover:scale-[12px] duration-300"
//           >
//             <div className="flex justify-between text-[#2A9CD7]">
//               <span className="flex items-center text-xs font-semibold  bg-blue-100 px-3 py-1 rounded-full mb-3">
//                 {job.category}
//               </span>
//               <span className="h-10 w-10 flex items-center justify-center bg-[#e4f0f6] group-hover:bg-[#2A9CD7] p-1 rounded-full duration-300">
//                 <Briefcase className="text-[#2A9CD7] group-hover:text-white duration-300" />
//               </span>
//             </div>
//             <h3
//               className="text-2xl md:text-3xl font-semibold mt-4 text-[#093A5B] group-hover:text-[#2A9CD7] duration-300"
//             >
//               {job.title}
//             </h3>
//             <p className="text-gray-600 mt-2 text-base md:text-lg">
//               {job.shortDescription}
//             </p>

//             <div className="flex items-center gap-4 text-gray-500 text-xs md:text-sm mt-5">
//               <div className="flex items-center gap-1">
//                 <MapPin size={16} /> {job.location}
//               </div>
//               <div className="flex items-center gap-1">
//                 <Clock size={16} /> {job.type}
//               </div>
//             </div>

//             <button
//               onClick={() => navigate(`/careers/${job.id}`)}
//               className="mt-5 inline-flex items-center gap-1 text-[#2A9CD7] font-medium text-sm md:text-base">
//               Apply Now <MoveRight className="group-hover:translate-x-2 duration-300" />
//             </button>
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// }

// import React, { useState, useEffect } from "react";
// import { Briefcase, MapPin, Clock, ArrowRight, MoveRight } from "lucide-react";
// import { useNavigate } from "react-router-dom";
// import { jobApi } from "../../data/JobData";

// const filters = [
//   "All",
//   "Engineering",
//   "Design",
//   "Marketing",
//   "Data",
//   "Customer Success",
// ];

// export default function OurPositions() {
//   const navigate = useNavigate();
//   const [active, setActive] = useState("All");
//   const [jobs, setJobs] = useState([]);
//   const [filteredPositions, setFilteredPositions] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   // Fetch jobs on component mount
//   useEffect(() => {
//     fetchJobs();
//   }, []);

//   // Filter jobs when active filter changes
//   useEffect(() => {
//     if (active === "All") {
//       setFilteredPositions(jobs);
//     } else {
//       const filtered = jobs.filter((job) => job.category === active);
//       setFilteredPositions(filtered);
//     }
//   }, [active, jobs]);

//   // API call to fetch jobs
//   const fetchJobs = async () => {
//     try {
//       setLoading(true);
//       setError(null);
//       const response = await jobApi.getAllJobs();
//       setJobs(response.data);
//     } catch (err) {
//       console.error("Error fetching jobs:", err);
//       setError("Failed to load job positions. Please try again later.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Fetch jobs by category (alternative approach)
//   const fetchJobsByCategory = async (category) => {
//     try {
//       setLoading(true);
//       setError(null);
//       const response = await jobApi.getJobsByCategory(category);
//       setJobs(response.data);
//     } catch (err) {
//       console.error("Error fetching jobs by category:", err);
//       setError("Failed to load job positions. Please try again later.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Handle filter change
//   const handleFilterChange = async (filter) => {
//     setActive(filter);
//     // Optional: Uncomment if you want to fetch from API on every filter change
//     // await fetchJobsByCategory(filter);
//   };

//   if (loading) {
//     return (
//       <div className="w-full py-20 px-4 lg:px-16 bg-gray-50 min-h-screen flex items-center justify-center">
//         <div className="text-center">
//           <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#2A9CD7] mx-auto"></div>
//           <p className="mt-4 text-gray-600">Loading job positions...</p>
//         </div>
//       </div>
//     );
//   }

//   if (error) {
//     return (
//       <div className="w-full py-20 px-4 lg:px-16 bg-gray-50 min-h-screen">
//         <div className="text-center">
//           <p className="text-red-500 mb-4">{error}</p>
//           <button
//             onClick={fetchJobs}
//             className="px-4 py-2 bg-[#2A9CD7] text-white rounded-lg hover:bg-[#093A5B] transition-colors"
//           >
//             Retry
//           </button>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="w-full py-20 px-4 lg:px-16 bg-gray-50 min-h-screen">
//       <div className="text-center space-y-6 mb-12">
//         <span className="text-[#2A9CD7] font-semibold tracking-wider text-sm px-4 py-2 rounded-full border border-blue-200">
//           OPEN POSITIONS
//         </span>
//         <h2 className="text-4xl md:text-5xl text-[#093a5b] font-bold">
//           Find Your Perfect Role
//         </h2>
//         <p className="text-gray-600 text-lg max-w-2xl mx-auto">
//           We're always looking for talented individuals who are passionate about
//           making an impact.
//         </p>
//       </div>

//       {/* Tabs */}
//       <div className="flex flex-wrap justify-center gap-3 mb-10">
//         {filters.map((filter) => (
//           <button
//             key={filter}
//             onClick={() => handleFilterChange(filter)}
//             className={`px-4 md:px-6 py-2 rounded-full text-sm md:text-base font-medium transition-all border shadow-sm duration-300
//               ${active === filter
//                 ? "bg-[#093A5B] text-white border-[#093A5B]"
//                 : "bg-white text-gray-600 border-gray-200 hover:border-[#2A9CD7]"
//               }`}
//           >
//             {filter}
//           </button>
//         ))}
//       </div>

//       {/* Job Cards */}
//       {filteredPositions.length === 0 ? (
//         <div className="text-center py-10">
//           <p className="text-gray-500 text-lg">
//             No job positions found for {active}. Please check back later.
//           </p>
//         </div>
//       ) : (
//         <div className="grid sm:grid-cols-2 lg:grid-cols-2 gap-6 max-w-6xl mx-auto">
//           {filteredPositions.map((job) => (
//             <div
//               key={job.id}
//               className="group bg-white p-6 rounded-xl shadow-sm border border-gray-200 hover:shadow-md transition-all hover:scale-[1.02] duration-300"
//             >
//               <div className="flex justify-between text-[#2A9CD7]">
//                 <span className="flex items-center text-xs font-semibold bg-blue-100 px-3 py-1 rounded-full mb-3">
//                   {job.category}
//                 </span>
//                 <span className="h-10 w-10 flex items-center justify-center bg-[#e4f0f6] group-hover:bg-[#2A9CD7] p-1 rounded-full duration-300">
//                   <Briefcase className="text-[#2A9CD7] group-hover:text-white duration-300" />
//                 </span>
//               </div>
//               <h3 className="text-2xl md:text-3xl font-semibold mt-4 text-[#093A5B] group-hover:text-[#2A9CD7] duration-300">
//                 {job.title}
//               </h3>
//               <p className="text-gray-600 mt-2 text-base md:text-lg">
//                 {job.shortDescription}
//               </p>

//               <div className="flex items-center gap-4 text-gray-500 text-xs md:text-sm mt-5">
//                 <div className="flex items-center gap-1">
//                   <MapPin size={16} /> {job.location}
//                 </div>
//                 <div className="flex items-center gap-1">
//                   <Clock size={16} /> {job.type}
//                 </div>
//               </div>

//               <button
//                 onClick={() => navigate(`/careers/${job.id}`)}
//                 className="mt-5 inline-flex items-center gap-1 text-[#2A9CD7] font-medium text-sm md:text-base hover:text-[#093A5B]"
//               >
//                 Apply Now{" "}
//                 <MoveRight className="group-hover:translate-x-2 duration-300" />
//               </button>
//             </div>
//           ))}
//         </div>
//       )}
//     </div>
//   );
// }

import React, { useState, useEffect } from "react";
import { Briefcase, MapPin, Clock, MoveRight } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { jobApi } from "../../data/JobData";

const filters = [
  "All",
  "Engineering",
  "Design",
  "Marketing",
  "Data",
  "Customer Success",
];

export default function OurPositions() {
  const navigate = useNavigate();
  const [active, setActive] = useState("All");
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Fetch jobs on component mount
  useEffect(() => {
    fetchJobs();
  }, []);

  // Fetch all jobs
  const fetchJobs = async () => {
    try {
      setLoading(true);
      setError(null);
      const response = await jobApi.getAllJobs();
      // console.log("Jobs API Response:", response);
      setJobs(response.data.data || []);
    } catch (err) {
      console.error("Error fetching jobs:", err);
      setError(
        err.response?.data?.message ||
          "Failed to load job positions. Please try again later.",
      );
    } finally {
      setLoading(false);
    }
  };

  // Filter jobs based on active category
  const filteredPositions =
    active === "All" ? jobs : jobs.filter((job) => job.category === active);

  // Handle filter change
  const handleFilterChange = (filter) => {
    setActive(filter);
  };

  // Handle retry
  const handleRetry = () => {
    fetchJobs();
  };

  if (loading) {
    return (
      <div className="w-full py-20 px-4 lg:px-16 bg-gray-50 min-h-screen flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#2A9CD7] mx-auto"></div>
          <p className="mt-4 text-gray-600">Loading job positions...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="w-full py-20 px-4 lg:px-16 bg-gray-50 min-h-screen">
        <div className="text-center max-w-2xl mx-auto">
          <div className="text-red-500 mb-4 p-4 bg-red-50 rounded-lg">
            <p className="font-semibold">Error Loading Jobs</p>
            <p className="text-sm mt-1">{error}</p>
          </div>
          <button
            onClick={handleRetry}
            className="px-6 py-3 bg-[#2A9CD7] text-white rounded-lg hover:bg-[#093A5B] transition-colors font-medium"
          >
            Retry Loading Jobs
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="w-full py-20 px-4 lg:px-16 bg-gray-50 min-h-screen">
      <div className="text-center space-y-6 mb-12">
        <span className="carrers_position_myclass">OPEN POSITIONS</span>
        <h2 className="carrers_prefectRole_myclass">Find Your Perfect Role</h2>
        <p className="carrers_para_myclass">
          We're always looking for talented individuals who are passionate about
          making an impact.
        </p>
      </div>

      {/* 30/12 close code Filter All,engineering, */}
      {/* Tabs */}
      {/* <div className="flex flex-wrap justify-center gap-3 mb-10">
        {filters.map((filter) => (
          <button
            key={filter}
            onClick={() => handleFilterChange(filter)}
            className={`px-4 md:px-6 py-2 rounded-full text-sm md:text-base font-medium transition-all border shadow-sm duration-300
              ${active === filter
                ? "bg-[#093A5B] text-white border-[#093A5B]"
                : "bg-white text-gray-600 border-gray-200 hover:border-[#2A9CD7]"
              }`}
          >
            {filter}
          </button>
        ))}
      </div> */}

      {/* Job Cards */}
      {jobs.length === 0 ? (
        <div className="text-center py-10">
          <p className="text-gray-500 text-lg">
            No job positions found for {active}. Please check back later.
          </p>
        </div>
      ) : (
        <div className="grid sm:grid-cols-2 lg:grid-cols-2 gap-6 max-w-6xl mx-auto">
          {jobs.map((job) => (
            <div
              key={job.id}
              className="group bg-white p-6 rounded-xl shadow-sm border border-gray-200 hover:shadow-md transition-all hover:scale-[1.02] duration-300"
            >
              <div className="flex justify-between text-[#2A9CD7]">
                <span className="flex items-center text-xs font-semibold bg-blue-100 px-3 py-1 rounded-full mb-3">
                  {job.category}
                </span>
                <span className="h-10 w-10 flex items-center justify-center bg-[#e4f0f6] group-hover:bg-[#2A9CD7] p-1 rounded-full duration-300">
                  <Briefcase className="text-[#2A9CD7] group-hover:text-white duration-300" />
                </span>
              </div>
              <h3 className="text-2xl md:text-3xl font-semibold mt-4 text-[#093A5B] group-hover:text-[#2A9CD7] duration-300">
                {job.heading}
              </h3>
              <p className="text-gray-600 mt-2 text-base md:text-lg">
                {job.subheading}
              </p>

              <div className="flex flex-wrap items-center gap-4 text-gray-500 text-xs md:text-sm mt-5">
                <div className="flex items-center gap-1">
                  <MapPin size={16} /> {job.location}
                </div>
                <div className="flex items-center gap-1">
                  <Clock size={16} />
                  {job.type}
                </div>
              </div>

              <button
                onClick={() => navigate(`/careers/${job.encrypted_id}`)}
                className="mt-5 inline-flex items-center gap-1 text-[#2A9CD7] font-medium text-sm md:text-base hover:text-[#093A5B]"
              >
                Apply Now{" "}
                <MoveRight className="group-hover:translate-x-2 duration-300" />
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
